export default __webpack_public_path__ + "static/media/mt.f69e2471.svg";